import React from "react";
import PropTypes from "prop-types";
import SVG_LOGO from "../../../assets/images/vector/components/common/ProAiBanner/logo.svg";
import "./index.scss";

const ProAiBanner = ({ clickHandler, proAiBannerRef }) => {
  return (
    <div className="PgESM-PAB" ref={proAiBannerRef}>
      <div className="PgESM-PAB-content" onClick={clickHandler}>
        <div className="PgESM-PAB-block">
          <img className="PgESM-PAB__logo" src={SVG_LOGO} alt="" />
          <div className="PgESM-PAB-title">
            <p className="PgESM-PAB-title__text">
              <b>DESBLOQUEA EL PODER DE LA IA</b> CON LA HERRAMIENTA DE
              INVESTIGACIÓN DE PRODUCTOS MÁS FÁCIL DE USAR*
            </p>
            <p className="PgESM-PAB-title__reference">
              *Según una encuesta de la comunidad de vendedores de Amazon
            </p>
          </div>
        </div>
        <button className="PgESM-PAB__cta">PRUEBA LA EXTENSIÓN PRO AI</button>
      </div>
    </div>
  );
};
ProAiBanner.propTypes = {
  clickHandler: PropTypes.func,
};
export default ProAiBanner;
